<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="warningRecordTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          <span>{{ data.row.isPublish === 1 ? '正常' : '禁用' }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteGoodsIndex',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_GOODS',
        formComponent: {
          view: { type: 'component', componentName: 'SiteGoodsCList', value: 'queryUserMessageDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/site/siteList' }
        },
        formInputsData: [
          { name: '站点名称', key: 'name', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [], filterable: true },
          { name: '状态',
            key: 'isPublish',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '正常', value: 1 },
              { label: '禁用', value: 0 }
            ] }],
        formButtonsData: [],
        formTableData: [
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '站点位置', key: 'address', type: 'text' },
          { name: '状态', key: 'isPublish', type: 'custom' }],
        formTableButtonsData: [{ name: '商品维护', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'MAINTAIN' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setSiteDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toClickAction(row, type) {
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认禁用？' : '确认启用？').then(() => {
        // request({
        //   url: '/modules/information/informationUpdateIsPublish',
        //   method: 'post',
        //   data: {
        //     informationId: row.id,
        //     isPublish: row.isPublish === 1 ? 0 : 1
        //   }
        // }).then(res => {
        //   if (res.code === '0') {
        //     this.$message({ message: '操作成功', type: 'success' })
        //     this.$refs.infoTableRef.requestList()
        //   }
        // })
      })
    },
    submitForm(formName) {
      // const that = this
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     request({
      //       url: '/modules/userIntegralDetails/userIntegralAdd',
      //       method: 'post',
      //       data: this.warningRecordForm
      //     }).then(res => {
      //       if (res.code === '0') {
      //         that.$message({ message: '保存成功', type: 'success' })
      //         this.$refs.warningRecordTableRef.requestList()
      //         that.handleDialogClose()
      //       }
      //     })
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    },
    handleDialogClose() {
      this.formDialog.visible = false
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.form.formInputsData[1].data = res.data
      })
    }
  }
}
</script>

<style>
</style>
